import { CheckIcon } from '@heroicons/react/24/outline';
import { cva, type VariantProps } from 'class-variance-authority';
import { InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/utils/classnameVariants';
import { ProgressStates } from '../../lib/utils/constants/progressStates';

export type CvaConfig = {
  variants: {
    state: { [key in (typeof ProgressStates)[number]]: string };
  };
  defaultVariants: { state: (typeof ProgressStates)[number] };
};

const progressBarStepVariants = cva(
  'inline-flex size-8 select-none flex-col items-center justify-center rounded-xl border border-black-900 text-center',
  {
    variants: {
      state: {
        pending: 'bg-white text-black-900',
        active: 'bg-black-900 text-white',
        done: 'bg-black-900 text-white',
      },
    },
    defaultVariants: {
      state: 'pending',
    },
  } satisfies CvaConfig,
);

export interface ProgressBarStepProps
  extends InputHTMLAttributes<HTMLDivElement>,
    VariantProps<typeof progressBarStepVariants> {
  state: (typeof ProgressStates)[number];
  step: number;
}

const ProgressBarStep = forwardRef<HTMLDivElement, ProgressBarStepProps>(
  ({ className, state, step, ...props }, ref) => (
    <div {...props} ref={ref} className={cn(progressBarStepVariants({ state }), className)}>
      {state === 'done' ? <CheckIcon className="size-4 stroke-2" /> : <p className="w-full text-center">{step}</p>}
    </div>
  ),
);
ProgressBarStep.displayName = 'ProgressBarStep';

export { ProgressBarStep };
